import React from 'react'
import { ElementProps } from '../base/element'
import { ICommonProps, IDefaultStyles } from '../schemamanager/types'

export interface ILabelComponent extends ICommonProps {
  type: 'label'
  label: string
}

const style: IDefaultStyles = {
  main: {
    classes: {
      textColor: 'text-gray-700'
    }
  }
}


export const Label = (props: ElementProps) => {
  const { events } = props
  const comp = props.comp as ILabelComponent
  const m = props.mergeStyles(style)

  return (
    <p {...m.main} {...events()}>
      {comp.label}
    </p>
  )
}
